import template from './tab.html'
import css from './tab.css'
import { TabController } from './tab.controller.js'

export const TabComponent = {
  template: template,
  controller: TabController,
  controllerAs: 'TabController',
  transclude: true,
  bindings: {
    title: '@',
    last: '@'
  },
  require: {
    parentTabs: '^^tabs'
  }
}



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/Tab/tab.component.js